import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Typography,
} from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import style from "./SubjectVisitManagement.module.css";
import { useNavigate } from "react-router-dom";
import { formatDateWithoutTime } from "../../../../utilities/helper";
import { getPatientDiaryDetailsService } from "../../../../services/subjectService";
import { useState } from "react";
import { BeatLoader } from "react-spinners";

const SubjectVisitManagement = ({ data }) => {
  const [load, setLoad] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [diaryDetails, setDiaryDetails] = useState(null);

  const navigate = useNavigate();

  const access_token = localStorage.getItem("access_token");

  const cultureCode = localStorage.getItem("currentUserCultureCode");
  const userId = localStorage.getItem("roleId");

  const getDiaryDetails = async (patientId, questionnaireId, visitId) => {
    try {
      setLoad(true);
      const res = await getPatientDiaryDetailsService(
        access_token,
        patientId,
        questionnaireId,
        visitId,
        userId,
        cultureCode
      );
      if (res?.status === 200) {
        setDiaryDetails(res?.data?.result[0]);
      }
      console.log("Diary Details Response:", res);
    } catch (err) {
      console.log("Error:", err?.message);
      if (err?.status == 401) {
        navigate("/unAuthorized");
      }
    } finally {
      setLoad(false);
    }
  };

  const handleAccordionChange = (event, isExpanded) => {
    setExpanded(isExpanded);
    if (isExpanded) {
      getDiaryDetails(data?.patientId, data?.questionnaireId, data?.visitId);
    }
  };

  return (
    <div
      style={{
        marginBottom: "20px",
      }}
    >
      <Accordion expanded={expanded} onChange={handleAccordionChange}>
        <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
          <div className={style.accordionSummary}>
            <div className={style?.visitContainer}>
              <Typography>
                {data?.visitName} {data?.patientVisitStatus}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {data?.visitDate
                  ? formatDateWithoutTime(data?.visitDate)
                  : "--"}
              </Typography>
            </div>

            <Chip
              sx={{ width: "100px" }}
              label={`${data?.diaryEntryCount} Entry`}
            />
          </div>
        </AccordionSummary>

        <AccordionDetails>
          {load ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <BeatLoader color="#3661eb" />
            </div>
          ) : (
            <table className={style?.table}>
              <thead className={style?.tableHead}>
                <tr>
                  <th className={style?.tableCell}>Visit Name</th>
                  <th className={style?.tableCell}>Visit Date</th>
                  <th className={style?.tableCell}>Start Time</th>
                </tr>
              </thead>
              <tbody>
                <tr className={style?.tableRow}>
                  <td className={style?.tableCell}>
                    <span
                      className={diaryDetails ? `bread-crumbs-btn` : ""}
                      style={{ fontSize: "medium", cursor: "pointer" }}
                      onClick={() => {
                        if (diaryDetails) {
                          navigate("/subject-visit-entry", {
                            state: {
                              id: diaryDetails?.id,
                            },
                          });
                        }
                      }}
                    >
                      {data?.visitName}
                    </span>
                  </td>
                  <td className={style?.tableCell}>
                    {data?.visitDate
                      ? formatDateWithoutTime(data?.visitDate)
                      : "--"}
                  </td>
                  <td className={style?.tableCell}>
                    {data?.visitDate
                      ? new Date(data?.visitDate).toTimeString().split(" ")[0]
                      : "--"}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default SubjectVisitManagement;
